<template>
    <v-form
        ref='send-apartment-options'
        lazy-validation
        v-model='validApartmentOptions'
        :disabled='loading'
        @submit.prevent='submitApartmentOptions(apartment)'
    >
        <v-row>
            <!--photos-->
            <v-col cols='12'>

                <ImageUploader
                    label='تصاویر مجموعه'
                    :selectForCover='selectForCover'
                    :coverIndex='coverIndex'
                    :target='`apartment--${apartment.title}?target=apartment`'
                    :disableUploadPhotoLength='6'
                    v-model='apartment.photos'
                >
                    <template #alert>
                        <InfoAlert>
                            <p class='mb-1 font-weight-bold'>
                                برای معرفی بهتر مجموعه تصاویر زیر پیشنهاد میشود
                            </p>
                            <ul class='pl-0 pr-4' style='column-count: 2'>
                                <li>نمای مجموعه</li>
                                <li>نقشه مجموعه</li>
                                <li>ورودی مجموعه</li>
                                <li>آسانسور ها</li>
                                <li>فضای سبز</li>
                                <li>پارکینگ</li>
                                <li>راهرو طبقات</li>
                                <li>اتاق مدیریت</li>
                                <li>نگهبانی</li>
                                <li>لابی</li>
                                <li>تیم مدیریتی و پرسنل</li>
                                <li>اتاق جلسات</li>
                                <li>باشگاه</li>
                                <li>موتور خانه</li>
                            </ul>
                        </InfoAlert>
                    </template>
                </ImageUploader>

            </v-col>
            <!--geoLocation-->
            <v-col class='mb-3' cols='12'>
                <div class='apartment-location' style='height: 300px'>
                    <p class='text--secondary subtitle-2 mb-2'>ثبت موقعیت مکانی</p>
                    <LMap
                        style='height:100%'
                        class='elevation-5'
                        @click='mapClick'
                        @ready='onReady'
                        @locationfound='onLocationFound'
                        setView
                        :center='[location.latlng.lat,location.latlng.lng]'
                        :zoom='12'
                    >
                        <LTileLayer
                            url='https://{s}.tile.osm.org/{z}/{x}/{y}.png'
                        ></LTileLayer>
                        <LMarker
                            v-if='locationFound'
                            :lat-lng='[apartment.geoLocation.lat,apartment.geoLocation.lng]'
                        >
                        </LMarker>
                    </LMap>
                </div>
            </v-col>
            <!--global options-->
            <v-col cols='12'>
                <v-row>
                    <!--designBy-->
                    <v-col cols='12' md="4">
                        <v-text-field
                            v-model='apartment.designBy'
                            placeholder='نام یا شرکت طراح مجموعه'
                            label='طراح'
                            hide-details
                            @focus='hideNavigationBar'
                            @blur='showNavigationBar'
                        />
                    </v-col>
                    <!--buildBy-->
                    <v-col cols='12' md="4">
                        <v-text-field
                            v-model='apartment.buildBy'
                            placeholder='نام یا شرکت سازنده مجموعه'
                            label='سازنده'
                            hide-details
                            @focus='hideNavigationBar'
                            @blur='showNavigationBar'
                        />
                    </v-col>
                    <!--yearOfConstruction-->
                    <v-col cols='12' md="4">
                        <v-text-field
                            v-model='apartment.yearOfConstruction'
                            placeholder='سال ساخت'
                            label='سال ساخت'
                            hide-details
                            @focus='hideNavigationBar'
                            @blur='showNavigationBar'
                        />
                    </v-col>
                    <!--parking-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.parking' class='rtl mt-0'>
                            <template #label>
                                <div><strong>پارکینگ</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--guard-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.guard' class='rtl mt-0'>
                            <template #label>
                                <div><strong>نگهبان</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--tree-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.tree' class='rtl mt-0'>
                            <template #label>
                                <div><strong>درخت</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--janitor-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.janitor' class='rtl mt-0'>
                            <template #label>
                                <div><strong>سرایدار</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--caretakerSuite-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.caretakerSuite'
                                    class='rtl mt-0'>
                            <template #label>
                                <div><strong>سوئیت سرایدار</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--greenSpace-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.greenSpace'
                                    class='rtl mt-0'>
                            <template #label>
                                <div><strong>فضای سبز</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--gardener-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.gardener' class='rtl mt-0'>
                            <template #label>
                                <div><strong>باغبان</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--pool-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.pool' class='rtl mt-0'>
                            <template #label>
                                <div><strong>استخر</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--babyPool-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.babyPool' class='rtl mt-0'>
                            <template #label>
                                <div><strong>استخر کودک</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--jacuzzi-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.jacuzzi' class='rtl mt-0'>
                            <template #label>
                                <div><strong>جکوزی</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--drySauna-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.drySauna' class='rtl mt-0'>
                            <template #label>
                                <div><strong>سونا خشک</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--steamSauna-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.steamSauna'
                                    class='rtl mt-0'>
                            <template #label>
                                <div><strong>سونا بخار</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--gym-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.gym' class='rtl mt-0'>
                            <template #label>
                                <div><strong>باشگاه ورزشی</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--sportField-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.sportField'
                                    class='rtl mt-0'>
                            <template #label>
                                <div><strong>زمین ورزشی</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--conference_hall-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.conference_hall'
                                    class='rtl mt-0'>
                            <template #label>
                                <div><strong>سالن اجتماعات</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--carwash-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.carwash' class='rtl mt-0'>
                            <template #label>
                                <div><strong>کارواش</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--supermarket-->
                    <v-col v-if='apartment.type ==="TOWN"' lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.supermarket'
                                    class='rtl mt-0'>
                            <template #label>
                                <div><strong>فروشگاه</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--roofGarden-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.roofGarden'
                                    class='rtl mt-0'>
                            <template #label>
                                <div><strong>روف گاردن</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--flowerBox-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.flowerBox' class='rtl mt-0'>
                            <template #label>
                                <div><strong>فلاور باکس</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--fountain-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.fountain' class='rtl mt-0'>
                            <template #label>
                                <div><strong>آبنما</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--gazebo-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.gazebo' class='rtl mt-0'>
                            <template #label>
                                <div><strong>آلاچیق</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--centralEngineRoom-->
                    <v-col v-if='apartment.type!== "TOWN"' lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.centralEngineRoom'
                                    class='rtl mt-0'>
                            <template #label>
                                <div><strong>موتورخانه مرکزی</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--chiller-->
                    <v-col v-if='apartment.type!== "TOWN"' lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.chiller' class='rtl mt-0'>
                            <template #label>
                                <div><strong>چیلر</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--elevator-->
                    <v-col v-if='apartment.type!== "TOWN"' lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.elevator' class='rtl mt-0'>
                            <template #label>
                                <div><strong>آسانسور</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--emergencyPower-->
                    <v-col v-if='apartment.type!== "TOWN"' lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.emergencyPower'
                                    class='rtl mt-0'>
                            <template #label>
                                <div><strong>برق اضطراری</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--fireAlarm-->
                    <v-col v-if='apartment.type!== "TOWN"' lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.fireAlarm' class='rtl mt-0'>
                            <template #label>
                                <div><strong>سیستم اعلام و اطفاء حریق</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--masterRoom-->
                    <v-col v-if='apartment.type!== "TOWN"' lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.masterRoom'
                                    class='rtl mt-0'>
                            <template #label>
                                <div><strong>اتاق مستر</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--receptionDesk-->
                    <v-col v-if='apartment.type!== "TOWN"' lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.receptionDesk'
                                    class='rtl mt-0'>
                            <template #label>
                                <div><strong>میز رسپشن</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--landry-->
                    <v-col v-if='apartment.type!== "TOWN"' lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.landry' class='rtl mt-0'>
                            <template #label>
                                <div><strong>لاندری</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--terrace-->
                    <v-col v-if='apartment.type!== "TOWN"' lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.terrace' class='rtl mt-0'>
                            <template #label>
                                <div><strong>تراس</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--lobby-->
                    <v-col v-if='apartment.type!== "TOWN"' lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.lobby' class='rtl mt-0'>
                            <template #label>
                                <div><strong>لابی</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--coffeeShop-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.coffeeShop'
                                    class='rtl mt-0'>
                            <template #label>
                                <div><strong>کافی شاپ</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--audioSystem-->
                    <v-col v-if='apartment.type!== "TOWN"' lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.audioSystem'
                                    class='rtl mt-0'>
                            <template #label>
                                <div><strong>سیستم صوتی</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--managerRoom-->
                    <v-col lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.managerRoom'
                                    class='rtl mt-0'>
                            <template #label>
                                <div><strong>اتاق مدیریت</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--suite-->
                    <v-col v-if='apartment.type!== "TOWN"' lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.suite' class='rtl mt-0'>
                            <template #label>
                                <div><strong>سوئیت</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--furnishKitchen-->
                    <v-col v-if='apartment.type!== "TOWN"' lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.furnishKitchen'
                                    class='rtl mt-0'>
                            <template #label>
                                <div><strong>آشپزخانه فرنیش</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--internet-->
                    <v-col v-if='apartment.type!== "TOWN"' lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.internet' class='rtl mt-0'>
                            <template #label>
                                <div><strong>اینترنت</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <!--safeBox-->
                    <v-col v-if='apartment.type!== "TOWN"' lg='3' md='4' sm='6' cols='12'>
                        <v-checkbox v-model='apartment.safeBox' class='rtl mt-0'>
                            <template #label>
                                <div><strong>صندوق امانات</strong></div>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <!--submit btn-->
        <v-row>
            <v-col cols='12'>
                <v-card-actions class='pa-0'>
                    <v-btn
                        outlined
                        @click='goToStep(step-1)'
                    >
                        مرحله قبل
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                        :loading='loading'
                        :disabled='loading'
                        type='submit'
                        color='primary'
                        @click='validateApartmentOptions'
                    >ثبت
                    </v-btn>
                </v-card-actions>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import axios from "axios";
import {createSupportRequest} from "@/plugins/createSupportRequest";
import InfoAlert from "@/components/Alerts/InfoAlert";
import {mapActions} from "vuex";
import {LMap, LMarker, LTileLayer} from "vue2-leaflet";
import ImageUploader from "@/components/ImageUploader";

export default {
    name: "completeInfo",
    components: {
        InfoAlert,
        LMap,
        LMarker,
        LTileLayer,
        ImageUploader,
    },
    props: {
        apartment: Object,
        goToStep: Function,
        step: Number,
        supportRequest_id: String
    },
    model: {
        prop: 'apartment',
        event: 'updateApartment'
    },
    data() {
        return {
            validApartmentOptions: false,
            loading: false,
            locationFound: false,


            location: {
                latlng: {
                    lat: 35.7035767,
                    lng: 51.0128825
                }
            },

            coverIndex: 0,
        }
    },
    methods: {


        validateApartmentOptions() {
            this.$refs['send-apartment-options'].validate();
            this.showNavigationBar();
        },

        async submitApartmentOptions(data) {
            this.loading = true;
            await axios
                .post(`/api/apartments/${this.apartment._id}/complete_info`, data)
                .then(async () => {
                    await createSupportRequest(this.supportRequest_id, {
                        text: 'ویرایش اطلاعات تکمیلی مجموعه'
                    });
                    this.$emit('updateApartment', this.apartment);
                    this.goToStep(this.step + 1);

                })
                .catch(err => {
                    console.error(err);
                    if (err.response) {
                        this.error = err.response;
                        this.errorDialog = true;
                    }
                });
            this.loading = false;
        },

        mapClick(e) {
            this.locationFound = false;
            this.apartment.geoLocation = {...e.latlng};
            this.locationFound = true;
        },
        async onLocationFound(location) {
            this.location = location;
            this.apartment.geoLocation = {
                lat: location.latitude,
                lng: location.longitude
            };
            this.locationFound = true;
        },

        onReady(location) {
            location.locate();
        },

        selectForCover(index) {
            this.coverIndex = index;
            this.apartment.cover = this.apartment.photos[index];
        },

        hideNavigationBar() {
            this.showNavigation(false);
        },
        showNavigationBar() {
            this.showNavigation(true);
        },
        ...mapActions([
            'setRole',
            'showNavigation',
            'showBreadCrumbs',
            'setBreadCrumbsTemp'
        ])
    }
}
</script>

<style scoped>

</style>